import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { HelpCircle, LifeBuoy, PlayCircle, MessageCircle, Phone } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { SUPPORT_WHATSAPP_URL } from '@/lib/utils/whatsapp';

const HELP_CENTER_URL = 'https://help.hostvsl.com.br/pt-br/';

export function HeaderHelpMenu() {
  useLanguage();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const items = [
    {
      icon: LifeBuoy,
      label: translateInterfaceText("Central de ajuda"),
      action: () => window.open(HELP_CENTER_URL, '_blank', 'noopener'),
    },
    { icon: PlayCircle, label: translateInterfaceText("Tutoriais"), action: () => navigate('/academy') },
    {
      icon: MessageCircle,
      label: translateInterfaceText("Falar no chat"),
      // Abre o chat do Crisp (mesmo caminho já usado no UserMenu)
      action: () => {
        if (window.$crisp) {
          window.$crisp.push(['do', 'chat:open']);
        }
      },
    },
    {
      icon: Phone,
      label: translateInterfaceText("Falar no WhatsApp"),
      action: () => window.open(SUPPORT_WHATSAPP_URL, '_blank', 'noopener'),
    },
  ];

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            'relative h-[42px] w-[42px] min-h-[42px] min-w-[42px] rounded-[10px] flex items-center justify-center group',
            'hover:bg-[#F1F5FF] transition-all duration-150 focus:outline-none',
            open && 'bg-[#F1F5FF]'
          )}
          aria-label={translateInterfaceText("Ajuda")}
        >
          <HelpCircle
            className="h-[20px] w-[20px] text-[#667085] group-hover:text-[#315FD5] transition-colors duration-150"
            strokeWidth={1.8}
          />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        sideOffset={6}
        className="w-[220px] rounded-[14px] border border-border/50 p-1.5 shadow-lg"
      >
        {items.map(({ icon: Icon, label, action }) => (
          <DropdownMenuItem
            key={label}
            onClick={action}
            className="group cursor-pointer rounded-[10px] px-2.5 py-2 text-[13px] font-medium text-[#3C4257] hover:bg-[#F1F5FF] hover:text-[#315FD5] focus:bg-[#F1F5FF] focus:text-[#315FD5] data-[highlighted]:bg-[#F1F5FF] data-[highlighted]:!text-[#315FD5] [&[data-highlighted]_svg]:!text-[#315FD5]"
          >
            <Icon
              className="mr-2.5 h-4 w-4 text-[#8A94A6] group-hover:text-[#315FD5] group-data-[highlighted]:text-[#315FD5]"
              strokeWidth={1.8}
            />
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
